import { Code, ConnectError } from '@connectrpc/connect';
import { useQuery } from '@tanstack/react-query';
import { getChatArtifact } from '../lib/api/chatArtifactApi.connect';
/**
 * An artifact the agent just streamed does not exist server-side until a human
 * saves it, so NotFound here is the expected state of a brand-new artifact, not
 * a failure. Retrying it three times just holds the drawer on a loading skeleton
 * while the content sits ready in the store.
 */ const isNotFound = (err)=>err instanceof ConnectError && err.code === Code.NotFound;
/**
 * Fetch a chat artifact and its version history over Connect (sabaody -> tesoro).
 *
 * Replaces GET /api/document/:id, which 403'd for every non-internal user. Reads
 * are now gated by the ownership-based `chat_artifact` Cerbos policy, evaluated
 * against the owner stored on the row.
 */ export const useGetDocument = (documentId, limit = 10, offset = 0)=>{
    return useQuery({
        queryKey: [
            'document',
            documentId,
            {
                limit,
                offset
            }
        ],
        queryFn: async ()=>{
            if (!documentId) {
                throw new Error('Document ID is required');
            }
            return getChatArtifact(documentId, limit, offset);
        },
        enabled: !!documentId,
        staleTime: 0,
        refetchOnMount: 'always',
        gcTime: 10 * 60 * 1000,
        retry: (failureCount, error)=>!isNotFound(error) && failureCount < 3
    });
};
